import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { connect } from "react-redux";

import Tabs from "ui-kit/Tabs/View";
import { TAB_INSTANCE_IDS } from "../constants";

import { actions } from "../model";
import styles from "./styles.scss";

import { getTabs, isFormValid } from "../selectors";

const decorate = R.compose(
  connect(
    state => ({
      isValid: isFormValid(state),
      tabs: getTabs(state)
    }),
    {
      showHasUnSavedChangesModal: () => actions.setHasUnSavedChangesModal(true),
      setTransitionToTabIdAfterSave: actions.setTransitionToTabIdAfterSave
    }
  ),
  CSSModules(styles)
);

const TabsComponent = ({
  isValid = true,
  showHasUnSavedChangesModal,
  setTransitionToTabIdAfterSave,
  tabs
}) => {
  return (
    <>
      <Tabs
        instanceId={TAB_INSTANCE_IDS}
        tabs={tabs}
        tabStyle={{
          fs: 3,
          className: "accentable-tab"
        }}
        style={{ borderBottom: "1px solid #e7e6ea", width: "100%" }}
        beforeOnClickHandler={tabId => {
          if (isValid) {
            showHasUnSavedChangesModal();
            setTransitionToTabIdAfterSave(tabId);
            return false;
          }
          return true;
        }}
      ></Tabs>
    </>
  );
};

export default decorate(TabsComponent);
